'use strict';

// src/utils/jsonSerialize.ts
var jsonSerialize = (obj) => {
  if (typeof obj === "string") {
    return JSON.parse(obj);
  }
  return obj;
};

exports.jsonSerialize = jsonSerialize;
